




































































































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import ConfirmDialog from '@/modules/shared/components/ConfirmDialog'
import {
  ResponseStatus,
  TournamentAPI,
  TournamentEntity,
  TournamentGroupAvailability
} from '@/api/tournament'
import {
  TournamentTeamEntity,
  TournamentPlayerEntity,
  TournamentTeamRole
} from '@/api/tournamentTeam'
import i18n from '@/lang'

@Component({
  components: {
    ConfirmDialog
  }
})
export default class EditTournamentGroupDialog extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  @PropSync('visible', { default: false }) isVisible!: boolean

  selectedGroup: string | null = null

  isGroupsLoading: boolean = false
  groups: TournamentGroupAvailability[] = []

  isConfirmDialogVisible: boolean = false
  isChangingGroup: boolean = false

  inGameNameRules: Function[] = [
    (v: any) => !!v || i18n.t('InGameNameRegistration.InGameNameIsRequired')
  ]

  /* Watchers */
  @Watch('isVisible')
  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.selectedGroup = null
    } else {
      if (this.selectedTournamentTeam) {
        this.selectedGroup = this.selectedTournamentTeam.group
      }
      this.fetchGroups().then()
    }
  }

  /* Methods */
  async fetchGroups() {
    this.isGroupsLoading = true

    try {
      const res = await TournamentAPI.getTournamentGroups(
        this.selectedTournament!.tournamentId
      )
      this.groups = res.data.payload!
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Landing.SystemErrorMessage'))
      }
    } finally {
      this.isGroupsLoading = false
    }
  }

  async changeGroup() {
    this.isChangingGroup = true
    try {
      const response = await TournamentAPI.editTournamentTeam(
        this.selectedTournamentTeam!.tournamentTeamId,
        {
          group: this.selectedGroup!
        }
      )
      if (response.data.status === ResponseStatus.Ok) {
        this.$toast.success(this.$t('EditTournamentGroupDialog.GroupChanged'))
        this.selectedGroup = null
        this.$emit('changed')
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Loading.SystemErrorMessage'))
      }

      console.error(err)
    } finally {
      this.isChangingGroup = false
      this.isConfirmDialogVisible = false
      this.isVisible = false
    }
  }

  /* Computed Properties */
  get selectedTournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get selectedTournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get canSelectGroup() {
    if (!this.selectedGroup) {
      return false
    }

    const group = this.groups.find(group => group.name === this.selectedGroup)
    if (!group) return false
    return group.available
  }

  get isSelectedGroupNotAvailable() {
    const group = this.groups.find(group => group.name === this.selectedGroup)
    if (!group) return false
    return !group.available
  }
}
